import { createSlice } from '@reduxjs/toolkit';
import { getBalance } from '../actions/GiftCardActions';
import {
  GIFT_CARD_NOT_FOUND,
  INVALID_CAPTCHA,
  SUBTITLE_ERROR,
} from '../../constants/texts';

const giftCardSlice = createSlice({
  name: 'gifcard',
  initialState: {
    getStatus: 'idle',
    balance: '0',
    expirationDate: '',
    errorMessage: '',
  },
  reducers: {
    resetGet(state) {
      state.getStatus = 'idle';
    },
  },
  extraReducers: {
    [getBalance.pending]: (state) => {
      state.getStatus = 'loading';
    },
    [getBalance.rejected]: (state, action) => {
      state.getStatus = 'error';
      if (action?.error?.message.includes('status code 404'))
        state.errorMessage = GIFT_CARD_NOT_FOUND;
      else if (action?.error?.message.includes('status code 400'))
        state.errorMessage = INVALID_CAPTCHA;
      else state.errorMessage = SUBTITLE_ERROR;
    },
    [getBalance.fulfilled]: (state, action) => {
      state.getStatus = 'succeded';
      state.balance = action?.payload?.montoDisponible || '';
      state.expirationDate = action?.payload?.fechaVcto || '';
    },
  },
});

export const { resetGet } = giftCardSlice.actions;
export default giftCardSlice.reducer;
